const dateFormatter = (timestamp) => {

  if (timestamp === undefined || timestamp === '') {
      return '';
  }

  const date = new Date(timestamp);

  const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true 
  };

  let formattedDate = date.toLocaleDateString('en-US', options);
  formattedDate = formattedDate.replace(' at ', ' '); 

  return formattedDate;
}

export default dateFormatter;